/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Components_File_Tree_Toast_Loading_TitleInputs */

const es_components_file_tree_toast_loading_title = /** @type {(inputs: Components_File_Tree_Toast_Loading_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Iniciando ingesta`)
};

const en_components_file_tree_toast_loading_title = /** @type {(inputs: Components_File_Tree_Toast_Loading_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Starting ingestion`)
};

/**
* | output |
* | --- |
* | "Starting ingestion" |
*
* @param {Components_File_Tree_Toast_Loading_TitleInputs} inputs
* @param {{ locale?: "es" | "en" }} options
* @returns {LocalizedString}
*/
const components_file_tree_toast_loading_title = /** @type {((inputs?: Components_File_Tree_Toast_Loading_TitleInputs, options?: { locale?: "es" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Components_File_Tree_Toast_Loading_TitleInputs, { locale?: "es" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_components_file_tree_toast_loading_title(inputs)
	return en_components_file_tree_toast_loading_title(inputs)
});
export { components_file_tree_toast_loading_title as "components.file_tree.toast_loading_title" }